//import 'ol/ol.css';
import * as toastr from "toastr";
import { IAPIResult, TextPack, ICAMSKey, FeatureType } from '../Models/UtilityModels';
import { Utilities, ModalAction } from '../Utility/Utilities';
import * as events from '../Bus/Bus';
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_InfraHistoric {

    // ----------------------------------------------------------- //
    // GLOBAL VARS

    // ----------------------------------------------------------- //

    // ----------------------------------------------------------- //
    // Defaults

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        const self = this;
    }

    // ----------------------------------------------------------- //
    // PUBLIC Functions
    
    public openHistoricPanel = (data: ICAMSKey, callback: Function): void => {
        const self = this;

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(window.G_SITEFOLDERNAME + '/Infra/InfraHistoricView', { uid: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#infraHistoricModal', ModalAction.Create);

            $('#infraHistoricCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#infraHistoricModal', ModalAction.Hide);
                callback(false);
            });

            $('#infraHistoricCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#infraHistoricModal', ModalAction.Hide);
                callback(false);
            });

            $('#infraHistoricDeleteBtn').on('click', function (evt) {
                self.deleteHistoric(data, callback);
            });
        });
    }

    // ----------------------------------------------------------- //
    // MISC
    public deleteHistoric = (data: ICAMSKey, callback: Function): void => {
        const self = this;

        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post(window.G_SITEFOLDERNAME + '/Infra/DeleteInfraHistoric', { uid: data.code },
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            events.bus.publish(events.eventRefreshMapLayer(FeatureType.InfraHistoric));
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }

                    }
                    catch (err) {
                        console.log(err);
                    }
                    finally {
                        Utilities.GetModal('#infraHistoricModal', ModalAction.Hide);
                        if (callback != null) callback(true);
                    };
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}